import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostUserChangePermissionRequest = {
	isLocked?: boolean;
	isReadOnly?: boolean;
	shardName?: string;
	userId: number;
};

export const postUserChangePermission = createPostEndpoint<PostUserChangePermissionRequest>(
	({ userId }) => `/api/v3/core/users/${userId}/change-permission`
);
